import { useGetShiplist, useUpdateShiplist } from '@ais-ui/api';
import { SaveShiplistDialog } from './SaveShiplistDialog';
import { Filter } from '@ais-ui/websockets';
import { DetailedShipList } from '@ais-ui/api-spec/config';
import { MutateShiplistProvider } from './MutateShiplistContext';

interface UpdateShiplistProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  shiplist: DetailedShipList;
}

export function EditShiplist(props: UpdateShiplistProps) {
  const { mutate } = useUpdateShiplist();

  const { data: detailedShiplist, isLoading } = useGetShiplist(
    props.shiplist.id as string
  );

  return (
    <MutateShiplistProvider
      showDialog={props.showDialog}
      setShowDialog={props.setShowDialog}
      shiplist={detailedShiplist}
      action={'edit'}
      mutate={mutate}
    >
      <SaveShiplistDialog></SaveShiplistDialog>
    </MutateShiplistProvider>
  );
}
